<template>
  <div>
    <div v-if="loading" class="item__loading">
      <Loading />
    </div>
    <div class="product singleproduct" v-else>
      <div class="product-wrapper">
        <div class="image-wrap">
          <!-- <img class="popup-img" :src="item.image" :alt="item.name" /> -->

          <img
            :src="
              item.image
                ? item.image
                : require('../../assets/images/default-img.jpg')
            "
            :alt="item.name"
          />
        </div>

        <!-- <div class="image-wrap" v-else>
          <img
            class="popup-img"
            src="../../assets/images/default-img.jpg"
            :alt="item.name"
          />
        </div> -->
        <div class="product-info" v-if="isFound">
          <div class="cross" @click="goBack">X</div>

          <div class="product-names">
            <div class="name" id="product-name">{{ item.name }}</div>

            <div class="cs_tagscontainer" v-if="item.cs_tags.name">
              {{ item.cs_tags.name }}
            </div>

            <div class="tagscontainer">
              <div
                v-for="items in item.tags_info"
                v-bind:key="items.id"
                class="tagsstyle"
                @click="handleSearch(items.name)"
              >
                {{ items.name }}
              </div>
            </div>

            <div class="prices">
              <div
                v-if="Number(item.before_price) > Number(item.after_price)"
                class="price beforeprice b_price"
              >
                Rs.{{ item.before_price }}
              </div>

              <div class="price">Rs.{{ item.after_price }}</div>
            </div>

            <div class="des-name">{{ item.short_description }}</div>

            <div class="order-button-wrap">
              <a-tooltip>
                <template slot="title">Add to cart</template>
                <div
                  class="add"
                  :class="{ active: !add }"
                  @click="addToCartCall(item)"
                >
                  Add
                </div>
              </a-tooltip>
              <div class="added" :class="{ active: add }">
                <a-button
                  class="order-button minus"
                  icon="minus"
                  @click="decreaseQuantity(item.id)"
                />
                {{ quantity }}
                <a-button
                  class="order-button plus"
                  icon="plus"
                  @click="increaseQuantity(item.id)"
                />
              </div>
            </div>
          </div>




        </div>

        <div class="no-product-container" v-else>
          <span class="no-product">Product Not Available.</span>
        </div>
      </div>
      <!-- eo product wrapper -->
    </div>

    <div class="linked-items-container" v-show="linkedItems.length > 0">
      <div class="linked-items-wrapper">
        <div class="demo menu-list-content">
          <div class="listSection">
            <span class="list-title">Dishes You May Also Like</span>

            <swiper ref="mySwiper" :options="swiperOptions">
              <swiper-slide
                class="menu-list"
                v-for="data in linkedItems"
                :key="data.id"
              >
                <HomePageProduct
                  v-bind:item="data"
                  :key="data.id"
                  v-on:view-product="viewProduct($event)"
                />
              </swiper-slide>

              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
        </div>
      </div>
    </div>

    <div v-if="popUpOn">
      <ProductPopup
        :item="popupProduct"
        v-on:close-popup="closePopup($event)"
      />
    </div>
  </div>
</template>





<script>
import axios from "axios";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

import { CartData, LocationId } from "../../services/storage.service";
import { GetItemDetail } from "../../services/items.service";
import { mapGetters, mapActions } from "vuex";

import router from "../../router";
import Loading from "../../components/Loading/Loading.vue";
import HomePageProduct from "../Home/ProductFeature/HomePageProduct.vue";
import ProductPopup from "../Home/ProductFeature/ProductPopup.vue";
import isEmpty from "../../utils/isEmpty";
import isUrl from "../../utils/isUrl";

export default {
  name: "Item",
  components: {
    Loading,
    Swiper,
    SwiperSlide,
    HomePageProduct,
    ProductPopup,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      add: false,
      quantity: 1,
      itemId: null,
      popUpOn: 0,
      item: {},
      loading: true,
      isFound: null,
      linkedItems: [],
      popupProduct: [],
      popUpOn: 0,

      swiperOptions: {
        slidesPerView: 2,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          320: {
            slidesPerView: 2,
            slidesToShow: 2,
            spaceBetween: 30,
          },
        },
      },
    };
  },
  created() {
    window.scrollTo(0, 0);

    if (this.$route.params.loc == "ktm") {
      this.updateLocationId(1);
    } else if (this.$route.params.loc == "pkr") {
      this.updateLocationId(2);
    }

    this.checkParams();
  },
  watch: {
    $route: function (n, o) {
      this.linkedItems = [];
      window.scrollTo(0, 0);
      this.closePopup();
      this.checkParams();
    },

    // whenever question changes, this function will run
    cartItems: function (newCartItems, oldCartItems) {
      CartData.setCartItems(newCartItems);

      if (newCartItems.length === 0) {
        (this.add = false), (this.quantity = 1);
        return;
      } else if (
        newCartItems.filter((food) => food.id == this.itemId).length == 0
      ) {
        this.quantity = 1;
        return;
      } else {
        this.quantity = newCartItems.filter(
          (food) => food.id === this.itemId
        )[0].quantity;
      }
    },

    itemId: function () {
      this.getLinkedItemsList();
    },
  },
  computed: {
    ...mapGetters(["cartItems"]),
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  methods: {
    ...mapActions([
      "addToCart",
      "addQuantity",
      "minusQuantity",
      "deleteItem",
      "updateLocationId",
    ]),



    injectProductSchema(){


// console.log("Building Schema")
// console.log(this.item);

      let schemaContent = "{";
      schemaContent += '"@context": "https://schema.org/", "@type": "Product", "name":';
      schemaContent += this.item.name;
      schemaContent += ',"image":'
      schemaContent += this.item.image
      schemaContent += ',"description":'
      schemaContent += this.item.short_description;
      schemaContent += '"brand": { "@type": "Brand","name": "Khaanpin"}, "gtin13": '
      schemaContent += this.item.id;
      schemaContent += "}"


      var schemaObject = document.getElementById('ProductSchemaScript')

      // console.log("++");
      // console.log(schemaObject);

      if(schemaObject){
        schemaObject.innerHTML= schemaContent;
      }
      else{

      let productSchema = document.createElement('script')
      productSchema.setAttribute('type', 'application/ld+json')
      productSchema.setAttribute('id', 'ProductSchemaScript')
      productSchema.innerHTML= schemaContent;
      document.head.appendChild(productSchema)
      }
      // console.log(schemaObject);

    },



    handleSearch(tag) {
      if (LocationId.getLocationId() == 1) {
        this.$router.replace({
          name: "Search",
          params: { loc: "ktm" },
          query: { q: tag },
        });
      } else if (LocationId.getLocationId() == 2) {
        this.$router.replace({
          name: "Search",
          params: { loc: "pkr" },
          query: { q: tag },
        });
      }
      this.searchText = "";
    },
    addToCartCall(item) {
      this.add = !this.add;
      this.addToCart(item);
    },
    increaseQuantity(id) {
      this.addQuantity(id);
    },
    decreaseQuantity(id) {
      if (this.quantity === 1) {
        this.add = false;
        this.deleteItem(id);
      } else {
        this.minusQuantity(id);
      }
    },
    checkParams: function () {
      //  console.log("::" + this.$route.params.slug )
      this.pageId = this.$route.params.slug;

      if (this.$route.params.slug != undefined) {
        this.hasV = 1;
        //if Number
        if (!isNaN(this.pageId)) {
          this.itemId = Number(this.pageId);
          this.loadItem(Number(this.pageId));
        }
        // endif NaN
        //if String
        else {
          // console.log("String Yo : " + this.pageId);
          //  router.push("/");
        }
        // end isnan string
      } else {
        this.hasV = 0;

        if (LocationId.getLocationId() == 1) {
          router.push("/ktm");
        } else if (LocationId.getLocationId() == 2) {
          router.push("/pkr");
        }
      }
    },

    loadItem: function (pageId) {
      GetItemDetail.getItems(Number(pageId), LocationId.getLocationId())
        .then((res) => {
          if (res.error == false) {
            this.loading = false;
            this.isFound = true;
            this.item = res.data[0];
            this.injectProductSchema();



                

        document.title =this.item.name +" | "+ this.$route.meta.title;  



          } else {
            this.loading = false;
            this.isFound = false;
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },

    viewProduct(product) {
      this.popupProduct = product;
      this.popUpOn = 1;
    },

    closePopup() {
      this.popUpOn = 0;
    },

    goBack: function () {
      router.push("/:loc?");
    },

    getLinkedItemsList() {
      axios
        .post("https://deus.khaanpin.com/appapi/linkeditems/", {
          id: this.itemId,
          loc_id: LocationId.getLocationId(),
        })
        .then((response) => {
          if (!response.data.error) {
            this.linkedItems = response.data.data;
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/variables.scss";

.item__loading {
  height: 30vw;
}

.b_price {
  margin-right: 15px !important;
}

.ant-modal-confirm-body {
  display: flex;
  justify-content: center;
  flex-direction: column;
  .ant-modal-confirm-title {
    text-align: center;
    margin-top: 20px;
  }
}
.ant-modal-confirm {
  .ant-modal-confirm-btns {
    float: none;
    width: 100%;
    display: flex;
    justify-content: center;
  }
}

.singleproduct {
  background: #333;
  position: relative;
  overflow: visible !important;
  height: auto;
  display: flex;

  .product-wrapper {
    width: 80%;
    background: #fff;
    margin: 0 auto;
    position: relative;
    top: 0px;
    box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.2);
    overflow: hidden;
    padding: 0;
    border-radius: 10px;

    .order-button-wrap {
      margin: 0 !important;
      text-align: left !important;
    }

    .image-wrap {
      float: left;
      width: 50%;
      img {
        width: 100%;
      }
    }

    .product-info {
      // background-color: gray;
      padding: 10px 10px 10px 20px;
      height: 100%;
      // display: flex;
      margin: 0px;
      float: left;
      text-align: left;
      width: 45%;
      // background-color: #ff6f30;
      align-items: flex-start;

      .name {
        font-size: 26px;
        font-family: $main-font;
      }
      .price {
        font-size: 22px;
        // margin-right: 20px;
        font-family: $main-font;
      }
      .order-button-wrap {
        margin: 0;
      }
    }
  }
}

.cs_tagscontainer {
  background-color: #ff6f30;
  border-radius: 10px;
  padding: 3px 4px;
  max-width: 12vw;
  // width: 100%;
  // text-align: center;
  // width: auto !important;
  text-transform: capitalize;
  color: #fff;
  font-family: $main-font;
  font-size: 10px;
  display: flex;
  height: auto;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
}

.cross {
  background-color: #ed2027;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 11px;
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
  height: 20px;
  width: 20px;
  border-radius: 10px;
  // display: inline-block;
  text-align: center;
}

.no-product-container {
  align-self: center;
  text-align: center;
  padding: 10px;
  display: flex;
  height: 100%;
  width: 50%;
  align-items: center;
  justify-content: center;
  .no-product {
    margin-top: 50%;
    font-size: 16px;
    font-family: $main-font;
  }
}

.linked-items-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
}

.linked-items-wrapper {
  width: 80%;
}

.listSection {
  background: #fff;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 30px;

  .menu-list {
    margin-top: 0px;
  }
  .list-title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
    display: inline-block;
    color: #ec3934;
  }
  .ant-item-list {
    margin: 0;
  }
  .product {
    margin-bottom: 0;
    .product-info {
      padding-bottom: 0;
    }
  }
}
</style>
